import stakeholder from './stakeholder'
import portal from './portal'

export const stakeholderService = stakeholder
export const portalService = portal